var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-audioguide',[_c('router-link',{attrs:{"slot":"title","to":"/"},slot:"title"},[_c('img',{attrs:{"src":require("@/assets/titles/et.svg")}})]),_c('audioguide',{attrs:{"slot":"audioguide","guides":_vm.guides},slot:"audioguide"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }